import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js"

/**
 * Controller for handling stone type selection and updating price dynamically
 */
export default class extends Controller {
    static values = {
        updateUrl: String,
        variantId: String
    }

    static targets = ["stoneType"]

    connect() {
        //console.log("Stone price updater controller connected")
    }

    /**
     * Handle stone type change and request updated price
     * @param {Event} event - The change event
     */
    async stoneTypeChanged(event) {
        const stoneTypeId = event.target.value

        if (!stoneTypeId || !this.variantIdValue) {
            console.error("Missing stone type or variant ID")
            return
        }

        // Get parameterized format from data-param attribute (e.g., "1-natural-diamonds")
        const selectedOption = event.target.selectedOptions[0]
        const stoneTypeParam = selectedOption?.dataset.param || stoneTypeId

        // Update the hidden field for cart submission (use numeric ID)
        const hiddenField = document.getElementById('stone_type_hidden')
        if (hiddenField) {
            hiddenField.value = stoneTypeId
        }

        // Update the browser URL with parameterized stone_type
        this.updateBrowserUrl(stoneTypeParam)

        // Create the URL with query parameters (use numeric ID for server)
        const url = new URL(this.updateUrlValue, window.location.origin)
        url.searchParams.append('variant_id', this.variantIdValue)
        url.searchParams.append('stone_type', stoneTypeId)

        try {
            // Use rails/request.js to make the request
            // This automatically handles Turbo Stream responses
            await get(url.toString(), {
                responseKind: "turbo-stream"
            })
        } catch (error) {
            console.error("Error updating price:", error)
        }
    }

    /**
     * Update the browser URL to include stone_type parameter
     * @param {string} stoneTypeParam - The selected stone type parameter (e.g., "1-natural-diamonds")
     */
    updateBrowserUrl(stoneTypeParam) {
        const url = new URL(window.location.href)
        url.searchParams.set('stone_type', stoneTypeParam)

        // Update the URL without reloading the page
        window.history.pushState({}, '', url.toString())
    }
}
